import { motion } from 'framer-motion'

const textContainer = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.015,
      delayChildren: 0.2
    }
  }
}

const wordAnimation = {
  hidden: { opacity: 0, y: 50 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      damping: 12,
      stiffness: 200
    }
  }
}

interface AnimatedTitleProps {
  text: string
  className?: string
  tag?: 'h1' | 'h2' | 'h3' | 'h4'
}

export const AnimatedTitle = ({ text, className = '', tag = 'h2' }: AnimatedTitleProps) => {
  const Component = motion[tag]

  const words = text.split(' ')

  return (
    <Component
      variants={textContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: '-100px' }}
      className={className}
    >
      {words.map((word, wordIndex) => (
        <span
          key={wordIndex}
          className="inline-flex whitespace-nowrap"
          style={{ marginRight: '0.25em' }}
        >
          {word.split('').map((char, charIndex) => (
            <motion.span
              key={`${wordIndex}-${charIndex}`}
              variants={wordAnimation}
              className="inline-block"
            >
              {char}
            </motion.span>
          ))}
        </span>
      ))}
    </Component>
  )
}
